import {Component, Inject, OnInit} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.css']
})
export class SnackbarComponent implements OnInit {
  openSnackBar(arg0: string, arg1: string, arg2: string) {

    throw new Error("Method not implemented.");
  }

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) { }

  ngOnInit() {
  }

  get getIcon() {
    switch (this.data.snackType) {
      case "Success":
        return "done";
      case "Error":
        return "error";
      case "Warn":
        return "warning";
      case "Info":
        return "info";
    }
  }

}
